import React from 'react';
import IconCheckCircle from '../../../../images/check-circle.svg';
// import IconErrorCircle from '../../../../images/error-yellow.svg';
import IconError from '../../../../images/error.svg';
import { OrderStatusERPEnum } from '../../../../constants/OrderStatusERP';

export const OrderStatusERPIcon = {
  [OrderStatusERPEnum.GENERATED]: () => <img src={IconCheckCircle} alt="Exportado" />,
  // [OrderStatusERPEnum.PENDING]: () => <img src={IconErrorCircle} alt="Aguardando" />,
  [OrderStatusERPEnum.ERROR]: () => <img src={IconError} alt="Erro" />,
};
